import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-derive-ico",
  "use": "icon-derive-ico-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-derive-ico\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 787.692308L787.692308 472.615385H630.153846V0H393.846154v472.615385H236.307692l275.692308 315.076923zM78.769231 866.461538h866.461538v157.538462H78.769231v-157.538462z\" fill=\"#888888\" p-id=\"1487\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol